const doc = [({"da":({"js":({"admin":({"election_posts":({"table":({"election_posts":"Valgposter"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;